import { render, staticRenderFns } from "./PostEvent.view.vue?vue&type=template&id=569633a2&"
import script from "./PostEvent.view.vue?vue&type=script&lang=js&"
export * from "./PostEvent.view.vue?vue&type=script&lang=js&"
import style0 from "./PostEvent.view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports